module.exports = __webpack_public_path__ + "img/设计号：正好是个设计鬼才.5cc596a9.png";